
import ApiService from "./api.service";



const CampaignService = {
    unsubscribe: async (campaignParticipantId: string) => {
        const url = `/api/campaign/unsubscribe`;
        const result = await ApiService.post<boolean>(url, { campaignParticipantId });
        return result;
      },
}


export default CampaignService;